import React from 'react';
import axios from 'axios';
import { Camera } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Identity only. Every HSS Application answer lives on the application record
// and is edited in the other Profile/Account tabs — no duplicate fields here.
const ProfileTab = ({ currentUser, setCurrentUser, getAuthConfig }) => {
  const patch = async (payload) => {
    try {
      const res = await axios.patch(`${API}/users/profile`, payload, getAuthConfig());
      setCurrentUser(prev => ({ ...prev, ...res.data }));
    } catch (err) { console.error('Profile update failed:', err); }
  };

  return (
    <div className="settings-section" data-testid="profile-section">
      <div style={{ background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
        <h3 style={{ margin: '0 0 20px 0', color: '#1a2332' }}>Member Identity</h3>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px' }}>
          <div style={{ position: 'relative' }}>
            {currentUser?.avatar_url ? (
              <img src={currentUser.avatar_url} alt="Avatar" style={{ width: '64px', height: '64px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #e5e7eb' }} />
            ) : (
              <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', fontWeight: '700', color: '#6b7280' }}>
                {currentUser?.name?.[0]?.toUpperCase()}
              </div>
            )}
            <label style={{ position: 'absolute', bottom: '-4px', right: '-4px', background: '#2563eb', color: 'white', borderRadius: '50%', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '12px', border: '2px solid white' }}>
              <Camera size={13} />
              <input type="file" accept="image/*" style={{ display: 'none' }}
                onChange={async (e) => {
                  const file = e.target.files[0];
                  if (!file) return;
                  const formData = new FormData();
                  formData.append('file', file);
                  try {
                    const res = await axios.post(`${API}/users/avatar`, formData, {
                      ...getAuthConfig(), headers: { ...getAuthConfig().headers, 'Content-Type': 'multipart/form-data' }
                    });
                    setCurrentUser(prev => ({ ...prev, avatar_url: res.data.avatar_url }));
                  } catch (err) { alert(err.response?.data?.detail || 'Upload failed'); }
                }}
                data-testid="avatar-upload-input" />
            </label>
          </div>
          <div>
            <div style={{ fontWeight: '700', fontSize: '16px', color: '#1a2332', display: 'flex', alignItems: 'center', gap: '8px' }}>
              {currentUser?.name}
              {currentUser?.membership_class === 'gold_envoy' && (
                <span style={{ background: 'linear-gradient(135deg, #b45309, #d97706)', color: 'white', fontSize: '11px', fontWeight: '900', padding: '3px 9px', borderRadius: '12px', letterSpacing: '0.05em' }} data-testid="gold-envoy-profile-badge">★ GOLD ENVOY</span>
              )}
            </div>
            <div style={{ fontSize: '13px', color: '#6b7280' }}>@{currentUser?.username || 'no-username'}</div>
            {currentUser?.membership_number && <div style={{ fontSize: '12px', color: '#6b7280' }}>Member No. {currentUser.membership_number}</div>}
          </div>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', fontSize: '14px' }}>Display Name</label>
          <input type="text" defaultValue={currentUser?.display_name || ''} placeholder="How you appear to other members"
            onBlur={(e) => patch({ display_name: e.target.value.trim() })}
            style={{ width: '100%', padding: '10px 12px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
            data-testid="display-name-input" />
          <span style={{ fontSize: '12px', color: '#9ca3af', marginTop: '4px', display: 'block' }}>Leave blank to use your username publicly</span>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', fontSize: '14px' }}>Short Bio</label>
          <textarea defaultValue={currentUser?.bio || ''} rows={3} placeholder="Tell other members a bit about yourself..."
            onBlur={(e) => patch({ bio: e.target.value })}
            style={{ width: '100%', padding: '10px 12px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' }}
            data-testid="profile-bio-input" />
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', fontSize: '14px' }}>Availability to Move In</label>
          <select defaultValue={currentUser?.availability || ''}
            onChange={(e) => patch({ availability: e.target.value })}
            style={{ width: '100%', padding: '10px 12px', border: '2px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
            data-testid="profile-availability-select">
            <option value="">Select availability...</option>
            {['Immediately', '1 week', '2 weeks', '1 month', '2 months', '3+ months', 'Flexible'].map(v => <option key={v} value={v}>{v}</option>)}
          </select>
          <span style={{ fontSize: '12px', color: '#9ca3af', marginTop: '4px', display: 'block' }}>This appears to property owners when you express interest.</span>
        </div>
        <p style={{ fontSize: '12px', color: '#9ca3af', marginTop: '16px', marginBottom: 0 }}>Changes save automatically when you click away from a field.</p>
      </div>
    </div>
  );
};

export default ProfileTab;
